import { setTerm } from './helpers';

export const setKitchenStove = setTerm('kitchen_stove');
